import { Text } from "../../../Components/Typography";
import { Card } from "../Card/Card";

import "./CardAddressType.scss";

interface Props {
  imgIcon: any;
  imgIconActive?: any;
  text: string;
  active?: boolean;
  onClick: any;
}

export const CardAddressType = ({
  imgIcon,
  imgIconActive,
  text,
  active,
  onClick,
}: Props) => (
  <Card className="card-address-type" active={active} onClick={onClick}>
    <img src={active && imgIconActive ? imgIconActive : imgIcon} alt="" />
    <Text>{text}</Text>
  </Card>
);
